import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {LibraryEntry} from '../../models';

@Component({
    selector: 'app-item-description-tab',
    templateUrl: './item-description-tab.component.html',
    standalone: false
})
export class ItemDescriptionTabComponent {
    @Input() entry: LibraryEntry;
    @Input() libraryType: string;
    @Input() formGroup: UntypedFormGroup;

}
